var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfConverter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#FFD9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16C23.5 19.5355 23.5 21.3033 22.4017 22.4017C21.3033 23.5 19.5355 23.5 16 23.5C12.4645 23.5 10.6967 23.5 9.59835 22.4017C8.5 21.3033 8.5 19.5355 8.5 16C8.5 12.4645 8.5 10.6967 9.59835 9.59835C10.6967 8.5 12.4645 8.5 16 8.5",
    stroke: "#323232",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.635 9.08245L21.5365 10.5252C22.8455 11.5183 23.5 12.0149 23.5 12.6598C23.5 13.3047 22.8455 13.8013 21.5365 14.7944L19.635 16.2371C19.0594 16.6738 18.7716 16.8922 18.5358 16.7979C18.3 16.7037 18.3 16.3703 18.3 15.7035V14.627C15.88 14.627 13.2583 15.6106 12.25 17.25C12.25 12.004 15.8352 10.6926 18.3 10.6926V9.6161C18.3 8.94931 18.3 8.61591 18.5358 8.52165C18.7716 8.42739 19.0594 8.64574 19.635 9.08245Z",
    stroke: "#323232",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfConverter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-converter.2810dc73931aa8feeea5ce26d25ad8b1.svg";